module.exports = __webpack_public_path__ + "img/foto-planta-tratamiento.eb5604c1.jpg";